var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-page",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"ad-page-bg",attrs:{"src":require("@/assets/img/chargingVoucher/ad-page-bg.jpg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }